import Md5 from 'crypto-js/md5';

const _k = (key, expireMinutes = 60 * 24 * 2) => {
  return {
    keyData: Md5(key).toString(),
    expireMinutes: expireMinutes,
  };
};

export const S_ITEMS = _k('S_ITEMS', 15);

export const S_LANG = _k('S_LANG', null);
export const S_SITE_ERRORS = _k('S_SITE_ERRORS', 15);
export const S_LOGIN_INFO = _k('S_LOGIN_INFO', null);
export const S_USER_INFO = _k('S_USER_INFO', null);
export const S_ORDER_INFO = _k('S_ORDER_INFO', null);
export const S_SHOP_ORDER_INFO = _k('S_SHOP_ORDER_INFO', null);
export const S_RESERVATION_DETAIL = _k('S_RESERVATION_DETAIL', null);
export const S_COUNTRIES = _k('S_COUNTRIES', 5);
export const S_DETAIL_LINK = _k('S_DETAIL_LINK', null);
export const S_SHIPPING_COUNTRIES = _k('S_SHIPPING_COUNTRIES', 5);
export const S_WEBSHOP_SHIPPING_COUNTRIES = _k('S_WEBSHOP_SHIPPING_COUNTRIES', 5);
export const S_REGISTRABLE_COUNTRIES = _k('S_REGISTRABLE_COUNTRIES', 5);
export const S_I18N = _k('S_I18N', 15);
export const S_LOGIN_URL = _k('S_LOGIN_URL', null);
export const S_MARKET_DETECTOR_CLOSED = _k('S_MARKET_DETECTOR_CLOSED', 60 * 24 * 2);
export const S_ORDER_STATUSES = _k('S_ORDER_STATUSES', 5);
export const S_ORDER_VEHICLE_STATUSES = _k('S_ORDER_VEHICLE_STATUSES', 5);
export const S_CAR_MODELS = _k('S_CAR_MODELS', 1);
export const S_CHAT_CONFIG = _k('S_CHAT_CONFIG', 5);
export const S_ORDER_LIST = _k('S_ORDER_LIST', 5);
export const S_MALL_ORDER_LIST = _k('S_MALL_ORDER_LIST', 5);
export const S_ORDER_RULES = _k('S_ORDER_RULES', 5);
export const S_PROVINCE_LIST = _k('S_PROVINCE_LIST', 5);
export const S_SANTANDER_LOAN = _k('S_SANTANDER_LOAN', 1);
export const S_CODE_WAVER_FINANCE = _k('S_CODE_WAVER_FINANCE', 2);
export const S_FINANCE_STATUSES = _k('S_FINANCE_STATUSES', 2);
export const S_ALL_CAR_PRICES = _k('S_ALL_CAR_PRICES', 5);

export const S_GLOBAL_CONFIG = _k('S_GLOBAL_CONFIG', 60);
export const S_BOUND_INFO = _k('S_BOUND_INFO', 2);
export const S_LANGUAGES = _k('S_LANGUAGES', 1);
export const S_STORE_TYPES = _k('S_STORE_TYPES', 5);
export const S_GEO_LOCATION = _k('S_GEO_LOCATION', 15);

export const S_SITE_INFO = _k('S_SITE_INFO', null);

export const S_AGREE = _k('S_AGREE', false);
export const S_CAR_MODEL_INFO = _k('S_CAR_MODEL_INFO', null);
export const S_STORE_INFO = _k('S_STORE_INFO', null);
export const S_TESTDRIVE_DATE_TIME = _k('S_TESTDRIVE_DATE_TIME', null);
export const S_TESTDRIVE_FORM_DATA = _k('S_TESTDRIVE_FORM_DATA', null);
export const S_PREORDER_FORM_DATA = _k('S_PREORDER_FORM_DATA', null);
export const S_STORE_LIST_CACHE = _k('S_STORE_LIST_CACHE', 30); // 门店列表缓存，30分钟过期
export const S_TESTDRIVE_STORE_LIST_CACHE = _k('S_TESTDRIVE_STORE_LIST_CACHE', 30); // 试驾门店列表缓存，30分钟过期
export const S_FORM_DATA_ARRAY = _k('S_FORM_DATA_ARRAY', null); // 表单数据数组存储

export const S_COMMON_VALIDATOR = _k('S_COMMON_VALIDATOR', 5);
// 过期时长可由 Sitecore globalConfig.leadFormExpireDays（天）覆盖；此处为未配置时的默认回退值（1 天）
export const S_LEAD_FORM_SUBMITTED = _k('S_LEAD_FORM_SUBMITTED', 60 * 24);
